<template>
<div class="bo-user-list-main">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>SPIADI</small><br>
        Zombies
      </h1>
      <hr>
    </div>
  </div>
  <sui-table :columns="table.columns"
            :actions="table.actions"
            :keyfield="table.keyfield"
            :list="all"
            :filterGen="filters"
            title="Zombies"
            :filter="filter"
            :filterVariables="filterVariables"
            ref="table"
            @cleanse="askForCleansing($event)"
            @info="getUserInfo($event)">
    <template slot="actions">
      <btn type="warning" @click="exportList" class="form-group">
        Export csv
      </btn>
    </template>
  </sui-table>
  <modal v-model="cleanseModal"
         @hide="cleanseModalEnded"
         title="Confirmation"
         ok-text="Oui" cancel-text="Non"
         ok-type="danger" cancel-type="primary">
    <p v-if="cleanseModal">
      Êtes vous certain.e de vouloir réanimer l'utilisateur
      {{ user.firstName }} {{ user.name }} ?
    </p>
  </modal>
  <user-modal :user="userInfoTarget" storePrefix="user"
              v-model="userInfoTrigger"></user-modal>
</div>
</template>

<script>
import stringify from 'csv-stringify'

import suiTable from '@/sui/components/table'
import userModal from '@/components/usermodal'
import filters from '@/tools/users/filters'
import saveBlob from '@/sui/components/saveblob'
import { mapState } from 'vuex'

export default {
  name: 'bo-zombie-list',

  data () {
    const cl = 'table-column-filter'
    const col = (e, f) => `${e} <span class='${cl}'>(${f})</span>`
    return {
      filter: '',
      filterVariables: [
        { key: 'id', field: 'id', name: 'ID utilisateur' },
        { key: 'n', field: 'name', name: 'Nom' },
        { key: 'p', field: 'firstName', name: 'Prénom' },
        { key: 'e', field: 'emails', name: 'E-mails' },
        { key: 'r', field: 'roles', name: 'Roles' }
      ],
      user: null,
      userInfoTarget: null,
      userInfoTrigger: false,
      cleanseModal: false,
      csv: {
        target: null
      },
      table: {
        columns: [
          {
            html: col('Nom', '$n'),
            field: 'name'
          },
          {
            html: col('Prénom', '$p'),
            field: 'firstName'
          },
          {
            html: col('Emails', '$e'),
            field: 'emails'
          },
          {
            html: col('Rôles', '$r'),
            field: 'roles'
          }
        ],
        actions: [
          {
            event: 'cleanse',
            name: 'Réanimer'
          }
        ],
        keyfield: 'id'
      }
    }
  },

  computed: {
    ...mapState({
      parentAll: state => state.user.zombies
    }),

    all: function () {
      const reducer = (result, u) => {
        result.push(
          {
            source: u,
            name: u.name,
            firstName: u.firstName,
            emails: u.email,
            roles: u.roles,
            id: u.id,
            filterlabel: `${u.name} ${u.firstName} ${u.email} ${u.id}`
          }
        )
        return result
      }
      return this.parentAll.reduce(reducer, [])
    },

    filters: function () {
      return filters
    }
  },

  created () {
    this.$store.dispatch('user/zombies')
  },

  methods: {
    askForCleansing: function (u) {
      this.cleanseModal = true
      this.user = u
    },

    cleanseModalEnded: function (msg) {
      if (msg === 'ok') {
        this.cleanse(this.user.id)
      }
      this.user = null
    },

    cleanse: function (id) {
      const vm = this
      this.$store.dispatch(`user/cleanse`, { i: id }).then(
        (response) => {
          if (response.data.err == null) {
            vm.$notify({
              type: 'success',
              title: 'Succès !',
              content: `Utilisateur ${id} réanimé avec succès.`
            })
            vm.$store.dispatch(`user/zombies`)
          } else {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Impossible de réanimer l'utilisateur ${id}: ${response.data.err}.`
            })
          }
        }).catch(function (e) {
        vm.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Impossible de réanimer l'utilisateur ${id}: ${e}.`
        })
      })
    },

    getUserInfo: function (u) {
      this.userInfoTarget = u.source
      this.userInfoTrigger = true
    },

    exportList: function (e) {
      const instance = this
      stringify(
        this.$refs.table.formattedList,
        {
          bom: true,
          header: true,
          delimiter: ';',
          cast: {
            boolean: function (b) {
              return { value: b ? 'Oui' : 'Non', quote: false }
            },
            object: function (v, ctx) {
              if (ctx.column !== 'emails' &&
                  ctx.column !== 'roles') {
                return JSON.Stringify(v)
              }

              const count = v.length
              if (count === 0) {
                return ''
              }

              let result = v[0]
              for (let i = 1; i !== count; ++i) {
                result = `${result}, ${v[i]}`
              }
              return result
            }

          },
          columns: [
            { key: 'name', header: 'Nom' },
            { key: 'firstName', header: 'Prénom' },
            { key: 'emails', header: 'Adresses e-mail' },
            { key: 'roles', header: 'Roles' }
          ]
        },

        function (err, output) {
          if (err != null) {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                instance.csv.target = {
                  filename: `bo-export-users.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    }
  },

  components: {
    'sui-table': suiTable,
    'user-modal': userModal,
    'save-blob': saveBlob
  }
}
</script>

<style scoped lang="less">
</style>
